<template>
	<div class="d_flex">
		<!-- Menu Area -->
		<div class="side_menu">
			<h2 class="mb_30">결제</h2>
			<ul class="left_content" ref="leftContent">
				<li
					v-for="(item, idx) in menuItems"
					:key="item"
					:class="{ active: selectedMenuIdx === idx }"
				>
					<a :href="`#${item.id}`" @click.prevent="toSection(idx)">{{
						item.value
					}}</a>
				</li>
			</ul>
		</div>
		<!-- Inner Area-->
		<div class="content_inner">
			<div class="inner_wrap">
				<div class="title">
					<h1 class="mb_20">결제</h1>
					<p>ONETETHER API를 이용한 결제 시스템</p>
				</div>

				<section ref="section1" id="section1">
					<h2 class="mb_20">Quick Guide</h2>
					<div class="develop_box_wrap">
						<div class="card tac mr_10 mb_0">
							<div class="arrow">
								<img
									src="@/assets/images/development/right_arrow.png"
									alt="right arrow"
								/>
							</div>
							<div class="round"></div>
							<h4 class="mb_10">회원 가입</h4>
							<p class="mb_16">ONETETHER 홈페이지에서 회원 가입을 해 주세요.</p>
							<!--							<button class="red">button</button>-->
						</div>
						<div class="card tac mr_10 mb_0">
							<div class="arrow">
								<img
									src="@/assets/images/development/right_arrow.png"
									alt="right arrow"
								/>
							</div>
							<div class="round"></div>
							<h4 class="mb_10">로그인</h4>
							<p class="mb_16">
								ONETETHER의 모든 서비스는 로그인 후 이용하실 수 있습니다.
							</p>
							<!--							<button class="red">button</button>-->
						</div>
						<div class="card tac mr_10 mb_0">
							<div class="arrow">
								<img
									src="@/assets/images/development/right_arrow.png"
									alt="right arrow"
								/>
							</div>
							<div class="round"></div>
							<h4 class="mb_10">가맹점 등록</h4>
							<p class="mb_16">
								가맹점 메뉴에서 가맹점 등록을 할 수 있습니다. 가맹점 이름과 ID를
								입력 해 주세요.
							</p>
							<!--							<button class="red">button</button>-->
						</div>
						<div class="card tac mb_0">
							<div class="round"></div>
							<h4 class="mb_10">API 발급</h4>
							<p class="mb_16">Lorem Ipsum Lorem Ipsum Lorem Ipsum</p>
							<!--							<button class="red">button</button>-->
						</div>
					</div>
				</section>

				<!-- tab type -->
				<section ref="section2" id="section2">
					<div class="card tab_type">
						<div class="d_flex mb_20 align_items_center step">
							<span>STEP 01</span>
							<h3>간편 결제</h3>
						</div>
						<div class="border_box">
							<h3 class="mb_10">Title</h3>
							<p>ONETETHER 결제 시스템으로 간편하게 이용하실 수 있습니다.</p>
							<ul class="list">
								<li>Lorem Ipsum Lorem Ipsum</li>
								<li>Lorem Ipsum Lorem Ipsum</li>
								<li>Lorem Ipsum Lorem Ipsum</li>
							</ul>
						</div>
						<!-- tab -->
						<ul class="tab_area mb_0">
							<li :class="{ selected: selectedTab === 1 }">
								<a class="tab_item" @click="tabSelect(1)">
									<span>필수 파라미터</span></a
								>
							</li>
							<li :class="{ selected: selectedTab === 2 }">
								<a class="tab_item" @click="tabSelect(2)"> <span>Tab</span></a>
							</li>
							<li :class="{ selected: selectedTab === 3 }">
								<a class="tab_item" @click="tabSelect(3)"> <span>Tab</span></a>
							</li>
							<li :class="{ selected: selectedTab === 4 }">
								<a class="tab_item" @click="tabSelect(4)"> <span>Tab</span></a>
							</li>
						</ul>

						<div class="tab_content">
							<div v-if="selectedTab === 1">
								<table>
									<colgroup>
										<col style="width: 20%" />
										<col />
										<col style="width: 25%" />
									</colgroup>
									<tbody>
										<tr>
											<th>merchant_name</th>
											<td>string</td>
											<td>
												<div class="tag_area">
													<div class="tag blue">Label</div>
													<div class="tag green">Label</div>
													<div class="tag">Label</div>
												</div>
											</td>
										</tr>
										<tr>
											<th>merchant_id</th>
											<td>string</td>
											<td>
												<div class="tag_area">
													<div class="tag yellow">Label</div>
													<div class="tag green">Label</div>
													<div class="tag">Label</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</section>

				<!-- info type -->
				<!--				<section ref="section3" id="section3">-->
				<!--					<div class="card mb_30 info_type">-->
				<!--						<h3 class="mb_10">Title</h3>-->
				<!--						<p>Lorem Ipsum Lorem Ipsum</p>-->
				<!--						<div class="mt_30">-->
				<!--							&lt;!&ndash; set &ndash;&gt;-->
				<!--							<div class="d_flex mb_16">-->
				<!--								<div class="info_left">-->
				<!--									<span>-->
				<!--										<img src="@/assets/images/development/check.png" alt="" />-->
				<!--									</span>-->
				<!--									<h4>Title</h4>-->
				<!--								</div>-->
				<!--								<div class="info_right">-->
				<!--									<p>Lorem Ipsum Lorem Ipsum</p>-->
				<!--								</div>-->
				<!--							</div>-->
				<!--							&lt;!&ndash; set &ndash;&gt;-->
				<!--							<div class="d_flex mb_16">-->
				<!--								<div class="info_left">-->
				<!--									<span>-->
				<!--										<img src="@/assets/images/development/check.png" alt="" />-->
				<!--									</span>-->
				<!--									<h4>Title</h4>-->
				<!--								</div>-->
				<!--								<div class="info_right">-->
				<!--									<p>Lorem Ipsum Lorem Ipsum</p>-->
				<!--								</div>-->
				<!--							</div>-->
				<!--							&lt;!&ndash; set &ndash;&gt;-->
				<!--							<div class="d_flex mb_16">-->
				<!--								<div class="info_left">-->
				<!--									<span>-->
				<!--										<img-->
				<!--											src="@/assets/images/development/check.png"-->
				<!--											alt="checked icon"-->
				<!--										/>-->
				<!--									</span>-->
				<!--									<h4>Title</h4>-->
				<!--								</div>-->
				<!--								<div class="info_right">-->
				<!--									<table class="table_type">-->
				<!--										<colgroup>-->
				<!--											<col style="width: 25%" />-->
				<!--											<col style="width: 25%" />-->
				<!--											<col style="width: 25%" />-->
				<!--											<col style="width: 25%" />-->
				<!--										</colgroup>-->
				<!--										<thead>-->
				<!--											<tr>-->
				<!--												<th>Lorem Ipsum</th>-->
				<!--												<th>Lorem Ipsum</th>-->
				<!--												<th>Lorem Ipsum</th>-->
				<!--												<th>Lorem Ipsum</th>-->
				<!--											</tr>-->
				<!--										</thead>-->
				<!--										<tbody>-->
				<!--											<tr>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--											</tr>-->
				<!--											<tr>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--												<td>test</td>-->
				<!--											</tr>-->
				<!--										</tbody>-->
				<!--									</table>-->
				<!--								</div>-->
				<!--							</div>-->
				<!--						</div>-->
				<!--					</div>-->
				<!--				</section>-->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DevelopMain.vue',
	data() {
		return {
			selectedTab: 1,
			selectedMenuIdx: 0,
			menuItems: [
				{
					id: 'section1',
					value: '가맹점 등록',
				},
				{
					id: 'section2',
					value: '간편 결제',
				},
				// {
				// 	id: 'section3',
				// 	value: 'Section 03',
				// 	isActive: false,
				// },
				// {
				// 	id: 'section4',
				// 	value: 'Section 04',
				// 	isActive: false,
				// },
				// {
				// 	id: 'section5',
				// 	value: 'Section 05',
				// 	isActive: false,
				// },
			],
		};
	},
	computed: {
		selectMenuItem() {
			return this.menuItems[this.selectedMenuIdx];
		},
	},
	methods: {
		tabSelect(e) {
			this.selectedTab = e;
		},
		toSection(idx) {
			this.selectedMenuIdx = idx;
			const targetEl = this.$refs[this.selectMenuItem.id];
			this.$smoothScroll({
				scrollTo: targetEl,
				updateHistory: false,
				offset: -100,
			});
		},
		scrollEvents() {
			const menuItems = this.menuItems;
			menuItems.forEach((item, idx) => {
				const sectionEl = this.$refs[item.id];
				const sectionTop = sectionEl.offsetTop;
				const sectionHeight = sectionEl.clientHeight;
				if (scrollY >= sectionTop - sectionHeight) {
					this.selectedMenuIdx = idx;
				}
			});
		},
	},
	mounted() {
		document.addEventListener('scroll', () => {
			let timer;
			if (!timer) {
				timer = setTimeout(() => {
					timer = null;
					this.scrollEvents();
				}, 400);
			}
		});
	},
	unmounted() {
		document.removeEventListener('scroll', this.scrollEvents);
	},
};
</script>
